<div class="faq-wrapper" fxFlexFill fxLayout="row" fxLayoutAlign="center center" fxFlex>
  <div class="faq-container" fxLayout="column" style="padding: 0 1em" fxFlex="60%" fxFlex.lt-md="100">
    <h1>{{ 'FAQ.TITLE' | translate }}</h1>
    <mat-tab-group>
      <mat-tab *ngFor="let subject of subjects|keyvalue">
        <ng-template matTabLabel>{{subject.key}}</ng-template>
        <mat-accordion multi>
          <mat-expansion-panel *ngFor="let q of subject.value">
            <mat-expansion-panel-header>
             {{q.q}}
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <p class="faq-answer">
                {{q.a}}
              </p>

            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

